export const headerContainerStyles = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
};

export const actionsContainerStyles = {
  display: 'flex',
  gap: '2rem',
  alignItems: 'center',
};
